import type { IntlShape } from 'react-intl';

export const getSearchConstants = (intl: IntlShape) => ({
  EXPORT_DUPLICATED_TEXT: intl.formatMessage({
    id: 'Constants.search.exportDuplicatedText',
    defaultMessage:
      'This export is already processing. It may take a few minutes.',
    description: 'Text shown when export is already processing',
  }),
  EXPORT_COMPLETED_TEXT: intl.formatMessage({
    id: 'Constants.search.exportCompletedText',
    defaultMessage: 'You will receive an email when the export is complete.',
    description: 'Text shown when export is completed',
  }),
  EXPORT_DEFAULT_TEXT: intl.formatMessage({
    id: 'Constants.search.exportDefaultText',
    defaultMessage: 'Export Excel',
    description: 'Default text for export button',
  }),
});

export const MIN_SEARCH_LENGTH = 2;

export const STATIC_COLUMNS = {
  ticket: ['name_Ticket'],
  document: ['name_Document', 'document_handler_id_Document'],
};

export const FIXED_COLUMNS = {
  ticket: ['name_Ticket'],
  document: ['name_Document'],
};
export const DEFAULT_SORT_BY = {
  document: { id: 'name_Document', desc: false },
  ticket: { id: 'name_Ticket', desc: false },
};
